module.exports = __webpack_public_path__ + "img/历史消息.6c0fc9fc.png";